import _ from "lodash";
import styled, { css } from "styled-components";
import { Controller } from "react-hook-form";
import { Select, Empty, Button } from "antd";

export const TSearchSelect = (props) => {
  const {
    control,
    label,
    name,
    data,
    disabled,
    placeholder,
    setValue,
    errors,
    onPilih,
    defaultValue,
    trigger,
  } = props;
  return (
    <StyledContainer isError={errors && _.get(errors, name)}>
      {label && (
        <div
          css={`
            display: flex;
            justify-content: space-between;
            align-items: center;
          `}
        >
          <StyledLabel htmlFor={name}>{label}</StyledLabel>
        </div>
      )}

      <Controller
        id={props.name}
        name={name}
        defaultValue={defaultValue}
        control={control}
        render={({ value }) => {
          const selectedValue = data?.find((data) => data.key === value);
          return (
            <StyledSelect
              showSearch
              defaultValue={defaultValue}
              error={_.get(errors, name)?.message || null}
              disabled={disabled || false}
              className={`styled-input ${
                props.errors && props.errors[props.name] && "input-error"
              }`}
              placeholder={placeholder}
              optionFilterProp="children"
              filterOption={(input, option) =>
                option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
              }
              notFoundContent={<Empty image={Empty.PRESENTED_IMAGE_SIMPLE} />}
              value={selectedValue?.text}
              onChange={(e) => {
                setValue(name, parseInt(e), {
                  shouldDirty: true,
                });
                if (onPilih) {
                  onPilih(parseInt(e));
                }
                trigger(name);
              }}
              style={{ width: "100%" }}
            >
              {data?.map((d) => (
                <Select.Option key={d.value}>{d.text}</Select.Option>
              ))}
            </StyledSelect>
          );
        }}
      />
      {errors && _.get(errors, name) && (
        <StyledError>
          <p>{errors && _.get(errors, name).message}</p>
        </StyledError>
      )}
    </StyledContainer>
  );
};

const StyledContainer = styled.div`
  display: flex;
  flex-direction: column;
  margin-bottom: ${(props) => props.theme.spacing[1]};
  .styled-input {
    &.input-error,
    .input-error:focus {
      outline: none !important;
      border: ${(props) => `1px solid
          ${props.theme.colors.red[400]}`};
    }
  }
  ${(props) =>
    props.isError &&
    css`
      margin-bottom: 0;
    `};
`;

const StyledLabel = styled.label`
  font-weight: 500;
  color: ${(props) => props.theme.colors.grey[600]};
`;

const StyledError = styled.span`
  color: ${(props) => props.theme.colors.red[600]};
  padding: 0;
  margin: 0;

  p {
    font-size: 0.8rem;
    margin: 0;
  }
`;

const StyledSelect = styled(Select)`
  ${(props) =>
    props.error &&
    css`
      .ant-select-selector {
        border-color: ${(props) => props.theme.colors.red[600]} !important;
      }
    `};
`;

const StyledButton = styled(Button)`
  padding: 0;
  margin: 0;
`;
